import React from 'react'
import Viewer from '@phuocng/react-pdf-viewer';
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import { defaultLayout } from '@phuocng/react-pdf-viewer';
import { Worker } from '@react-pdf-viewer/core';


class RenderPdf extends React.Component {
  constructor(props) {
      super(props);      
        this.state = {
        }
      }

      renderToolbar = (toolbarSlot) => {
        return (
            <div
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    width: '100%',
                }}
            >
                <div
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        flexGrow: 1,
                        flexShrink: 1,
                        justifyContent: 'center',
                    }}
                >
                    <div style={{ padding: '0 2px' }}>
                        {toolbarSlot.previousPageButton}
                    </div>
                    <div style={{ padding: '0 2px' }}>
                        {toolbarSlot.currentPage + 1} / {toolbarSlot.numPages}
                    </div>
                    <div style={{ padding: '0 2px' }}>
                        {toolbarSlot.nextPageButton}
                    </div>
                    <div style={{ padding: '0 2px' }}>
                        {toolbarSlot.zoomOutButton}
                    </div>
                    <div style={{ padding: '0 2px' }}>
                        {toolbarSlot.zoomPopover}
                    </div>
                    <div style={{ padding: '0 2px' }}>
                        {toolbarSlot.zoomInButton}
                    </div>
                </div>
            </div>
        );
      };

      layout = (
        isSidebarOpened,
        container,
        main,
        toolbar,
        sidebar,
      ) => {
        return defaultLayout(
            isSidebarOpened,
            container,
            main,
            toolbar(this.renderToolbar),
            sidebar,
        );
      }


    render() {
      return (
          <div style={{ height: '650px' }}>
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                  <Viewer fileUrl={this.props.file}  layout={this.layout}/>
              </Worker>
          </div>
      )
    }
  }

export default RenderPdf